import { render, staticRenderFns } from "./tagDetailPopup.vue?vue&type=template&id=4628b83c&scoped=true&"
import script from "./tagDetailPopup.vue?vue&type=script&lang=js&"
export * from "./tagDetailPopup.vue?vue&type=script&lang=js&"
import style0 from "./tagDetailPopup.vue?vue&type=style&index=0&id=4628b83c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4628b83c",
  null
  
)

export default component.exports